module.exports = __webpack_public_path__ + "img/72_M14_track_changes.a2636257.jpg";